import { useExamContext } from "@features/exam/contexts/ExamContext";
import { usePodcasts } from "@features/podcasts/hooks/usePodcasts";
import { getShowStudyPackViews } from "@helpers/exams";
import { isWeb } from "@helpers/platform";
import { useAppStore } from "@hooks/useAppStore";

const useFeaturesSection = ({
	isFetchingItemsCount,
	practiceTestSubtitle,
	studyPackSubtitle,
	numPracticeTests,
}: {
	isFetchingItemsCount: boolean;
	practiceTestSubtitle: string;
	studyPackSubtitle: string;
	numPracticeTests: number;
}) => {
	const {
		currentExamContext: { examName, studyPackCollectionId },
	} = useExamContext();
	const section = {
		sectionTitle: examName || "Current Exam",
		type: "exam",
		onPress: undefined,
		data: [],
	};

	const { originalPodcasts } = usePodcasts();

	const showPodcasts = originalPodcasts && originalPodcasts.length > 0;

	const practiceTestsLabel = useAppStore(
		(state) => state.exam.practiceTest?.label,
	);
	const practiceTestEnabled = useAppStore(
		(state) => state.exam.practiceTest?.enabled,
	);

	const showStudypackListItem = getShowStudyPackViews(studyPackCollectionId);

	const featuresSectionData = isFetchingItemsCount
		? {
				...section,
				loading: isFetchingItemsCount,
			}
		: {
				...section,
				loading: false,
				data: [
					...(numPracticeTests > 0 &&
					(isWeb ? practiceTestEnabled.web : practiceTestEnabled.mobile)
						? [
								{
									title: practiceTestsLabel || "Practice Tests",
									subtitle: practiceTestSubtitle,
									link: "/practice-tests",
									icon: "clipboard-check-outline" as const,
									type: "practice-tests" as const,
								},
							]
						: []),
					...(showStudypackListItem
						? [
								{
									title: "Study Pack",
									subtitle: studyPackSubtitle,
									link: "/study-pack/",
									icon: "study-pack-outline",
									custom: true,
									type: "study-pack" as const,
								},
							]
						: []),
					...(showPodcasts
						? [
								{
									title: "Listen to podcasts",
									subtitle: `${originalPodcasts.length} podcasts`,
									link: "/podcasts",
									icon: "book-open-page-variant-outline",
									type: "podcasts" as const,
								},
							]
						: []),
				],
			};

	return { featuresSectionData };
};
export default useFeaturesSection;
